import styles from "./PixelGridLoader.module.css";

const pixels = Array.from({ length: 9 }, (_, index) => {
   const row = Math.floor(index / 3);
   const column = index % 3;
   return {
      id: `${row}-${column}`,
      delay: (column + Math.abs(row - 1)) * 90,
   };
});

/** Decorative Dots loader; the surrounding status supplies its accessible label. */
export default function PixelGridLoader() {
   return (
      <span aria-hidden="true" className="grid shrink-0 grid-cols-[repeat(3,4px)] gap-[1.5px]">
         {pixels.map(({id, delay}) => (
            <span
               key={id}
               className={`size-[4px] rounded-full bg-current ${styles.pixel}`}
               style={{ animationDelay: `${delay}ms` }}
            />
         ))}
      </span>
   );
}
